import type { GateFn } from '../gates.types'
import { Experiments } from 'CustomOptimizelyProvider'
import { PossibleVariants } from 'utils/tracking/optimizely/types'

/** Creates a predicate that checks if the user is in specific variant(s) of an experiment */
export const inExperiment =
  (exp: Experiments, ...variants: PossibleVariants[]): GateFn =>
  (ctx) =>
    variants.includes(ctx.experimentData[exp] as PossibleVariants)
